import { Link, useParams } from 'react-router'
import { AppShell } from '../../app/AppShell'
import { Button, Card } from '../../design/components'
import { ComposerScreen } from '../../domains/composer/ComposerScreen'
import { useCharacterSheet } from '../../domains/characters/queries'
import styles from '../../domains/composer/composer.module.css'

/**
 * The portrait workbench.
 *
 * Thin over `ComposerScreen`, which is shared with the location composer: the two screens differ
 * in who may use them, what their tools offer and what a saved result becomes, and in nothing
 * else (`docs/web-api/phase-9-kickoff.md` §1, decision 5).
 */
export function PortraitComposerPage() {
  const params = useParams<{ id: string }>()
  const characterId = Number(params.id)

  const sheet = useCharacterSheet(characterId, null)

  const isOwner = sheet.data?.isOwner === true
  const name = sheet.data?.sections.core?.name ?? 'Character'

  if (Number.isNaN(characterId)) {
    return (
      <AppShell title="Compose">
        <Card>
          <p className={styles.note}>That character id is not a number.</p>
        </Card>
      </AppShell>
    )
  }

  return (
    <ComposerScreen
      owner={{ kind: 'character', characterId }}
      subjectName={name}
      subtitle="COMPOSE"
      canCompose={isOwner}
      generateWhat="Sends the prompt above, in order. The result arrives as a draft; nothing is saved until you save it."
      generateAction="Generate"
      downloadName="portrait"
      back={
        <Link to={`/characters/${characterId}/images`}>
          <Button variant="secondary" fullWidth>
            Back to the gallery
          </Button>
        </Link>
      }
    />
  )
}
